import axios from "axios";

export const saveData = async (props) => {
    const values = { ...props.formValues };
    const apiName = props.apiName;
    console.log(values);
    console.log("apiName", props.apiName);

    const url = `${process.env.REACT_APP_BASE_URL}/api/${apiName}`;

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("datos guardados...");
        }
    })

    return result;
};
